import React from 'react';

import {withRouter, WithRouterProps} from 'react-router';

import {
  applyFilter,
  DashboardFilterbar,
} from 'app/general/dashboards/DashboardFilterbar';
import {SearchInputField} from 'app/general/widgets/SearchInputField';

import type {TeamsLocationParamsType} from 'app/teams/types';

interface Props extends WithRouterProps<TeamsLocationParamsType> {
  viewingAll: boolean;
  resetFilters: () => void;
}

export const TeamsDashboardFilterbar = withRouter(
  ({router, location, resetFilters, viewingAll}: Props) => {
    const {query} = location;

    function onSearch(search: string) {
      applyFilter(router, location, {search});
    }

    return (
      <DashboardFilterbar resetFilters={resetFilters} viewingAll={viewingAll}>
        <div className="col">
          <SearchInputField
            value={query.search != null ? query.search : ''}
            onChange={onSearch}
          />
        </div>
      </DashboardFilterbar>
    );
  }
);
